import { render } from "./UpdateGame.vue?vue&type=template&id=2ae452fd&scoped=true"
import script from "./UpdateGame.vue?vue&type=script&lang=js"
export * from "./UpdateGame.vue?vue&type=script&lang=js"

import "./UpdateGame.vue?vue&type=style&index=0&id=2ae452fd&scoped=true&lang=css"
import "./UpdateGame.vue?vue&type=style&index=1&id=2ae452fd&lang=scss"
import "./UpdateGame.vue?vue&type=style&index=2&id=2ae452fd&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae452fd"]])

export default __exports__